import { typesPedidoVenta as types } from "../../types";

const initialState = {
  pedidosventas: [],
  paginator: null,
  visibleModal: false,
  activePedidoVenta: null,
  activeDetallePedidoVenta: null,
  loading: false,
};
export const pedidoventaReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.dataLoading:
      return { ...state, loading: action.payload };
    case types.pedidosventasLoaded:
      return {
        ...state,
        pedidosventas: action.payload?.results,
        paginator: action.payload,
      };
    case types.pedidoventaShowModalItemDetalle:
      return {
        ...state,
        visibleModal: action.payload,
      };
    case types.pedidoventaAdded:
      return {
        ...state,
        pedidosventas: [...state.pedidosventas, action.payload],
      };
    case types.pedidoventaSetActive:
      return {
        ...state,
        activePedidoVenta: action.payload,
      };
    case types.pedidoventaClearActive:
      return {
        ...state,
        activePedidoVenta: null,
      };
    case types.detallePedidoVentaSetActive:
      return {
        ...state,
        activeDetallePedidoVenta: action.payload,
      };
    case types.detallePedidoVentaClearActive:
      return {
        ...state,
        activeDetallePedidoVenta: null,
      };
    case types.pedidoventaUpdated:
      return {
        ...state,
        pedidosventas: state.pedidosventas.map((e) =>
          e.id === action.payload.id ? action.payload : e,
        ),
      };
    case types.pedidoventaDeleted:
      return {
        ...state,
        pedidosventas: state.pedidosventas.filter(
          (e) => e.id !== action.payload.id,
        ),
        activePedidoVenta: null,
      };
    case types.pedidoventaLogout:
      return { ...initialState };
    default:
      return state;
  }
};
